<template>
  <m-layout-mask :key="$i18n.locale && isUserLoggedIn">
    <div class="board-head">
      <icon-button @click="$router.go(-1)">
        <i-back class="icon" />
      </icon-button>
    </div>
    <iframe
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
      allowfullscreen
      v-show="isUserLoggedIn"
      v-bind:src="url">
    </iframe>
    <bet-slip-warning v-if="!isUserLoggedIn" style="margin-left: calc(50% - 160px); margin-top: 20px;">
      {{ $t('bet-slip.warnings.guest.0') }}<br>
      <m-textito style="background: unset !important; color: white !important; border-radius: 10px;" @click="$store.commit('SHOW_MODAL', 'LOGIN')">{{ $t('bet-slip.warnings.guest.1') }}</m-textito>
      {{ $t('bet-slip.warnings.guest.2') }}
      <m-textito style="background: unset !important; color: white !important; border-radius: 10px;" @click="$store.commit('SHOW_MODAL', 'REGISTER')">{{ $t('bet-slip.warnings.guest.3') }}</m-textito>
    </bet-slip-warning>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import IconButton from '@/components/buttons/IconButton'
import IBack from 'vue-material-design-icons/ArrowLeft'
import MTextito from '@/components/MTextito'
import BetSlipWarning from '@/components/fon-bet-slip/BetSlipWarning'
import { mapState } from 'vuex'

export default {
  components: { MLayoutMask, IBack, IconButton, MTextito, BetSlipWarning },
  computed: {
    ...mapState({
      user: state => state.user,
      isUserLoggedIn: state => state.isUserLoggedIn
    })
  },
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    if (this.user !== null) {
      this.url = 'https://rate.sportdemo.ru/inbet/sitegame/token/' + this.user.token + '/game/' + this.$route.params.id + '/lang/' + this.$i18n.locale
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      if (this.user !== null) {
        this.url = 'https://rate.sportdemo.ru/inbet/sitegame/token/' + this.user.token + '/game/' + this.$route.params.id + '/lang/' + this.$i18n.locale
      }
    }
  }
}
</script>

<style scoped>
.board-head { background: rgba(38, 50, 56, .9); display: flex; height: 100%; line-height: 40px; border: 1px solid hsla(0,0%,100%,.07); }
.board-head .icon-button { color: #fff; font-size: 24px; height: 100% }
</style>



// WEBPACK FOOTER //
// src/components/kazino/Game.vue